export enum ClientStatus {
  VISITOR = 'VISITOR',
  LEAD = 'LEAD',
  CLIENT = 'CLIENT',
}
